import { FUEL_LINE_ITEM_TYPES, LANDING_LINE_ITEM_TYPES, MIN_HELI, MIN_PILOT, OTHER_CHARGES_LINE_ITEM_TYPES, PER_DIEMS_LINE_ITEM_TYPES } from "../../sharedCode/metadata";
import { Maybe, TicketLineItem } from "../../sharedCode/avroGraphql";
import { PersonExtended } from "../../Utils/TypeExtensions";

export function isFuelLineItem(lineItem: Maybe<TicketLineItem>): boolean {
    return FUEL_LINE_ITEM_TYPES.findIndex((id) => id === lineItem?.line_item_type_id) >= 0;
}

export function isChargeLineItem(lineItem: Maybe<TicketLineItem>): boolean {
    return OTHER_CHARGES_LINE_ITEM_TYPES.findIndex((id) => id === lineItem?.line_item_type_id) >= 0;
}

export function isLandingLineItem(lineItem: Maybe<TicketLineItem>): boolean {
    return LANDING_LINE_ITEM_TYPES.findIndex((id) => id === lineItem?.line_item_type_id) >= 0;
}

export function isMinimumsLineItem(lineItem: Maybe<TicketLineItem>): boolean {
    return lineItem?.line_item_type_id === MIN_HELI || lineItem?.line_item_type_id === MIN_PILOT; // NB pilot mins are still in LineItems but aren't shown, so we can't use the types array here (it's used to render the form)
}

export function isPerDiemLineItem(lineItem: Maybe<TicketLineItem>): boolean {
    return PER_DIEMS_LINE_ITEM_TYPES.findIndex((id) => id === lineItem?.line_item_type_id) >= 0;
}

export function isAdminUser(user: PersonExtended): boolean {
    const adminUsers = [
        { first_name: "LAVERNE", last_name: "KELLY" },
        { first_name: "SEAN", last_name: "KELLY" },
        { first_name: "KIMBERLY", last_name: "KELLY" },
        { first_name: "MARK", last_name: "BANNAN" },
    ];

    return (
        adminUsers.findIndex((p) => {
            return p.first_name.localeCompare(user.first_name?.toLocaleUpperCase() ?? "") == 0 && p.last_name.localeCompare(user.last_name?.toLocaleUpperCase() ?? "") == 0;
        }) >= 0
    );
}

export function isSuperUser(user: PersonExtended): boolean {
    const superUsers = [
        { first_name: "TANYA", last_name: "MCCOLL" },
        { first_name: "PAUL", last_name: "RUDY" },
        { first_name: "DAVIN", last_name: "MCLEAN" },
        { first_name: "SHAWN", last_name: "STONE" },
    ];

    const isSuperUser =
        superUsers.findIndex((p) => {
            return p.first_name.localeCompare(user.first_name?.toLocaleUpperCase() ?? "") == 0 && p.last_name.localeCompare(user.last_name?.toLocaleUpperCase() ?? "") == 0;
        }) >= 0;

    return isSuperUser ? isSuperUser : isAdminUser(user);
}
